import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Simple Prev / Next pagination for paginated list endpoints.
 * Expects { page, pages, total, onChange } — onChange(newPage).
 * Renders nothing if there is only a single page of data.
 */
export default function Pagination({ page, pages, total, onChange, testId = "pagination" }) {
  if (!pages || pages <= 1) return null;
  const prev = () => onChange(Math.max(1, page - 1));
  const next = () => onChange(Math.min(pages, page + 1));
  return (
    <div className="flex items-center justify-between gap-3 px-4 py-3 border-t border-border bg-accent/10"
         data-testid={testId}>
      <div className="text-xs text-muted-foreground">
        Page <span className="font-semibold text-primary">{page}</span> of{" "}
        <span className="font-semibold text-primary">{pages}</span>
        {typeof total === "number" && <> · {total} total</>}
      </div>
      <div className="flex gap-1">
        <button
          type="button"
          onClick={prev}
          disabled={page <= 1}
          className="accp-btn-ghost text-xs disabled:opacity-40 disabled:cursor-not-allowed"
          data-testid={`${testId}-prev`}
          aria-label="Previous page"
        >
          <ChevronLeft size={14} /> Prev
        </button>
        <button
          type="button"
          onClick={next}
          disabled={page >= pages}
          className="accp-btn-ghost text-xs disabled:opacity-40 disabled:cursor-not-allowed"
          data-testid={`${testId}-next`}
          aria-label="Next page"
        >
          Next <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
}
